export type PaginationPageToken = number | "ellipsis";

/**
 * Computes visible page tokens for a sliding window around the current page.
 * For totalPages > 5, keeps first/last anchors and up to three inner pages with ellipses.
 */
export function getVisiblePaginationPages(
  currentPage: number,
  totalPages: number
): PaginationPageToken[] {
  if (!Number.isFinite(totalPages) || totalPages < 1) {
    return [];
  }

  const total = Math.floor(totalPages);
  const current = Math.min(Math.max(1, Math.floor(currentPage)), total);

  if (total <= 5) {
    return Array.from({ length: total }, (_, index) => index + 1);
  }

  const tokens: PaginationPageToken[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);

  if (start > 2) {
    tokens.push("ellipsis");
  }

  for (let page = start; page <= end; page += 1) {
    tokens.push(page);
  }

  if (end < total - 1) {
    tokens.push("ellipsis");
  }

  tokens.push(total);
  return tokens;
}
